import UniversalProvider from '@walletconnect/universal-provider';
import { WcHelpersUtil } from '@reown/appkit';
import { WalletConnectConnector } from '@reown/appkit/connectors';
import { AddressPurpose } from '../utils/BitcoinConnector.js';
import { ProviderEventEmitter } from '../utils/ProviderEventEmitter.js';
export class BitcoinWalletConnectConnector extends WalletConnectConnector {
    constructor({ provider, chains, getActiveChain }) {
        super({ provider, caipNetworks: chains, namespace: 'bip122' });
        this.eventEmitter = new ProviderEventEmitter();
        this.emit = this.eventEmitter.emit.bind(this.eventEmitter);
        this.on = this.eventEmitter.on.bind(this.eventEmitter);
        this.removeListener = this.eventEmitter.removeListener.bind(this.eventEmitter);
        this.getActiveChain = getActiveChain;
    }
    // -- Public ------------------------------------------- //
    get chains() {
        return this.sessionChains
            .map(chainId => this.caipNetworks.find(chain => chain.caipNetworkId === chainId))
            .filter(Boolean);
    }
    async connect() {
        return Promise.reject(new Error('Connection of WalletConnectProvider should be done via UniversalAdapter'));
    }
    async signMessage({ message, address, protocol }) {
        this.checkIfMethodIsSupported('signMessage');
        const signedMessage = await this.internalRequest({
            method: 'signMessage',
            params: { message, account: address, address, protocol }
        });
        return Buffer.from(signedMessage.signature, 'hex').toString('base64');
    }
    async sendTransfer({ recipient, amount }) {
        this.checkIfMethodIsSupported('sendTransfer');
        const account = this.getAccount(true);
        const result = await this.internalRequest({
            method: 'sendTransfer',
            params: {
                account,
                recipientAddress: recipient,
                amount
            }
        });
        return result.txid;
    }
    async getAccountAddresses() {
        this.checkIfMethodIsSupported('getAccountAddresses');
        const addresses = await this.internalRequest({
            method: 'getAccountAddresses',
            params: undefined
        });
        return addresses.map(address => ({ address, purpose: AddressPurpose.Payment }));
    }
    async signPSBT(params) {
        this.checkIfMethodIsSupported('signPsbt');
        const account = this.getAccount(true);
        const response = await this.internalRequest({
            method: 'signPsbt',
            params: {
                account,
                psbt: params.psbt,
                signInputs: params.signInputs,
                broadcast: params.broadcast
            }
        });
        return {
            psbt: response.psbt,
            txid: response.txid
        };
    }
    async switchNetwork(_caipNetworkId) {
        // ChainAdapterBlueprint.switchNetwork will be called instead
        return Promise.resolve();
    }
    request(args) {
        // @ts-expect-error - args type should match internalRequest arguments but it's not correctly typed in Provider
        return this.internalRequest(args);
    }
    // -- Private ------------------------------------------ //
    get sessionChains() {
        return WcHelpersUtil.getChainsFromNamespaces(this.provider.session?.namespaces);
    }
    getAccount(required) {
        const account = this.provider.session?.namespaces['bip122']?.accounts[0];
        if (!account) {
            if (required) {
                throw new Error('Account not found');
            }
            return undefined;
        }
        const address = account.split(':')[2];
        if (!address) {
            if (required) {
                throw new Error('Address not found');
            }
            return undefined;
        }
        return address;
    }
    checkIfMethodIsSupported(method) {
        if (!this.provider.session?.namespaces['bip122']?.methods.includes(method)) {
            throw new Error(`Method ${method} is not supported`);
        }
    }
    async internalRequest({ method, params }) {
        const chain = this.getActiveChain();
        if (!chain) {
            throw new Error('Chain not found');
        }
        return await this.provider.request({
            method,
            params
        }, chain.caipNetworkId);
    }
}
//# sourceMappingURL=BitcoinWalletConnectConnector.js.map